module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C123"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Contents#id_1220",
      "id": "page_xiv"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "P31"
  }, [_c('strong', [_vm._v("Lorien Foote:")]), _vm._v(" I thank my co-editor, Kanisorn Wongsrichanalai, for approaching me with the idea for this volume and for making the process so pleasant and so easy. He is a fine historian and a good friend. I would like to thank the series editor, Andy Slap, for answering many questions along the way and providing me, as he always does, with his expertise, guidance, and friendship. The entire staff at Fordham University Press deserves recognition for their professionalism, in particular Fredric Nachbaur and Will Cerbone. Thank you to Joan Waugh for writing the foreword to this volume and for modeling how to practice the historian’s craft.")]), _vm._v(" "), _c('p', {
    staticClass: "C150"
  }, [_c('strong', [_vm._v("Kanisorn Wongsrichanalai:")]), _vm._v(" As one of the co-editors of this volume, I thank all the contributors for their hard work, the anonymous readers for their insightful suggestions, and Lorien Foote for her professionalism, dedication, and friendship. I also express my gratitude to the former series editor, Paul A. Cimbala, and the current series editor, Andrew L. Slap, for their consistent support and encouragement. Many thanks also go out to Fredric Nachbaur, Will Cerbone, and the professionals at Fordham University Press.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f502576","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Acknowledgments.vue
// module id = 81
// module chunks = 0